import classNames from 'classnames';

import CloseIcon from '../icons/Close';
import Button from './Button';

import styles from '../../../styles/buttons/close.module.css';

interface CloseButtonProps {
    className?: string | null;
}

function CloseButton({ className = null, ...props }: CloseButtonProps) {
    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            aria-label="Close"
            {...props}
        >
            <CloseIcon className={classNames(['fullscreen', styles.icon])} fat aria-hidden="true" />
        </Button>
    );
}

export default CloseButton;
